import { useEffect, useState, type ReactNode } from 'react';
import './Maintenance.css';

export default function MaintenanceGate({ children }: { children: ReactNode }) {
  const [maintenance, setMaintenance] = useState(false);
  useEffect(() => {
    let disposed = false;
    let checking = false;
    let controller: AbortController | undefined;
    const check = async () => {
      if (checking) return;
      checking = true;
      controller = new AbortController();
      const requestController = controller;
      const timeout = window.setTimeout(() => requestController.abort(), 8000);
      try {
        const response = await fetch('/api/appointments/site-status', { cache: 'no-store', signal: requestController.signal });
        if (response.ok) {
          const data = await response.json();
          if (!disposed && typeof data.maintenance === 'boolean') setMaintenance(data.maintenance);
        }
      } catch { /* The server also enforces maintenance on public requests. */ }
      finally { window.clearTimeout(timeout); checking = false; }
    };
    void check();
    const timer = window.setInterval(() => { void check(); }, 15000);
    window.addEventListener('focus', check);
    return () => { disposed = true; controller?.abort(); window.clearInterval(timer); window.removeEventListener('focus', check); };
  }, []);

  if (!maintenance) return children;
  return <main className="maintenance-screen" role="status">
    <div className="maintenance-card">
      <div className="maintenance-brand">Summit<span>Fix</span></div>
      <div className="maintenance-sign" aria-hidden="true">!</div>
      <p className="maintenance-label">MAINTENANCE IN PROGRESS</p>
      <h1>Website temporarily unavailable</h1>
      <p className="maintenance-copy">We’re making a few updates to improve your experience. Please check back shortly. Thank you for your patience.</p>
      <button className="maintenance-retry" onClick={() => window.location.reload()}>Try again</button>
    </div>
  </main>;
}
